import React, { useState } from 'react';
import styled from 'styled-components';
import AboutUs from '../../components/AboutUs/AboutUs';
import Cities from '../../components/Cities/Cities';
import HeaderDescription from '../../components/Description/Description';
import Footer from '../../components/Footer/Footer';
import Form from '../../components/Form/Form';
import Header from '../../components/Header/Header';
import Modal from '../../components/Modal/Modal';
import OfficeDescription from '../../components/OfficeDescription/OfficeDescription';


const MainPageComponent = styled.div<{ status: boolean }>`
  position: relative;
  height: ${props => (props.status ? '100vh' : 'unset')};
`;

const MainPage: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [status, setStatus] = useState('default');
    return (
        <MainPageComponent status={status === 'formSent'}>
            <Header isVisible={isVisible} setIsVisible={setIsVisible} />
            <HeaderDescription />
            <Cities />
            <OfficeDescription />
            <AboutUs />
            <Form status={status} setStatus={setStatus} isVisible={isVisible} />
            <Footer />
            {isVisible && (
                <Modal
                    setIsVisible={setIsVisible}
                    status={status}
                    setStatus={setStatus}
                    isVisible={isVisible}
                />
            )}
        </MainPageComponent>
    );
};

export default MainPage;
